// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Option from "../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function getBasicContactInfo(order) {
  return {
          booking_number: order.customer_info.customer_mobile,
          sender_contact: order.pickup_info.contact.number,
          receiver_contact: Belt_Option.mapWithDefault(order.drop_info, "N/A", (function (l) {
                  return l.contact.number;
                })),
          partner_mobile_number: "N/A",
          partner_secondary_number: "N/A",
          goods_type: Belt_Option.getWithDefault(order.goods_type, "N/A"),
          delivery_instructions: order.delivery_instructions
        };
}

function getCancelledOrderInfo(order, cancelled_order) {
  var partner = cancelled_order.partner_info;
  if (partner === undefined) {
    return getBasicContactInfo(order);
  }
  var init = getBasicContactInfo(order);
  return {
          booking_number: init.booking_number,
          sender_contact: init.sender_contact,
          receiver_contact: init.receiver_contact,
          partner_mobile_number: partner.mobile,
          partner_secondary_number: partner.secondary_mobile,
          goods_type: init.goods_type,
          delivery_instructions: init.delivery_instructions
        };
}

function getVm(order) {
  var order$1;
  var accepted_order;
  var exit = 0;
  switch (order.TAG | 0) {
    case /* Open */0 :
        return getBasicContactInfo(order._0);
    case /* Accepted */1 :
    case /* Live */2 :
    case /* Ended */3 :
        exit = 2;
        break;
    case /* Cancelled */4 :
        return getCancelledOrderInfo(order._0, order._1);
    default:
      order$1 = order._0;
      accepted_order = order._2;
  }
  if (exit === 2) {
    order$1 = order._0;
    accepted_order = order._1;
  }
  var init = getBasicContactInfo(order$1);
  return {
          booking_number: init.booking_number,
          sender_contact: init.sender_contact,
          receiver_contact: init.receiver_contact,
          partner_mobile_number: accepted_order.partner_info.mobile,
          partner_secondary_number: accepted_order.partner_info.secondary_mobile,
          goods_type: init.goods_type,
          delivery_instructions: init.delivery_instructions
        };
}

export {
  getBasicContactInfo ,
  getCancelledOrderInfo ,
  getVm ,
  
}
/* No side effect */
